import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LegalShell = ({ title, effective, children }) => (
    <div className="min-h-screen bg-[#F9F6F0] text-[#2C1A12]">
        <header className="border-b border-[#E8DCCB]/60">
            <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
                <Link
                    to="/"
                    className="flex items-center gap-2 text-sm font-semibold text-[#8C7A72] hover:text-[#2C1A12]"
                >
                    <ArrowLeft className="h-4 w-4" strokeWidth={2.5} /> Home
                </Link>
                <div className="font-display font-black text-xl">
                    Coffee<span className="text-[#FF4F18]">in7.</span>
                </div>
                <div className="w-14" />
            </div>
        </header>
        <div className="max-w-3xl mx-auto px-6 py-12">
            <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#FF4F18]">Legal</div>
            <h1 className="mt-2 font-display font-black text-4xl">{title}</h1>
            <div className="mt-2 text-sm text-[#8C7A72]">Effective: {effective}</div>
            <div className="mt-8 prose prose-sm max-w-none space-y-5 text-[#2C1A12]/90 leading-relaxed">
                {children}
            </div>
            <div className="mt-12 pt-8 border-t border-[#E8DCCB] text-sm text-[#8C7A72]">
                Questions? Contact us at{" "}
                <a href="mailto:admin@coffeein7.com" className="text-[#FF4F18] hover:underline">
                    admin@coffeein7.com
                </a>
                .
            </div>
        </div>
    </div>
);

export default LegalShell;
